<template>
    <ModalComponent
        :name="name"
        :title="title"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">{{confirmButton}}</h1>
            </div>
            <div class="col-12 text-center">
                <label for="nombre">Mensaje (Texto que le llegara al correo del solicitante)</label>
                <QuillEditor v-model="mensaje"/>
            </div>
            <div class="col-12 text-center mt-4">
                <Button type="button" name="button" @click="confirm">{{buttom}}</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import QuillEditor from "@/modules/ui/QuillEditor.vue";
    export default {
        props: {
            name: String,
            title: String,
            buttom: String,
            confirmButton: String,
            cancelar: Boolean
        },
        data(){
            return {
                mensaje: '',
                conf: {},
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            confirm() {
                this.$emit('confirm', this.mensaje);
            }
        },
        components: {
            ModalComponent, QuillEditor
        }
    }
</script>
